import {
  LOCAL_INCOMING_SHIPMENT,
  LOCAL_INCOMING_SHIPMENT_VEHICLE_TYPES,
  LOCAL_OUTGOING_SHIPMENT,
  LOCAL_OUTGOING_SHIPMENT_VEHICLE_TYPES,
} from "../../../apiServices/API_ENDPOINTS";
import {
  LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
  LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
  LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
} from "../../../routes/permissions";

const configs = {
  outgoing: {
    label: "Outgoing",
    api: LOCAL_OUTGOING_SHIPMENT,
    vehicleTypesApi: LOCAL_OUTGOING_SHIPMENT_VEHICLE_TYPES,
    listPath: "/local/outgoing",
    addPath: "/local/add-outgoing",
    editPath: "/local/edit-outgoing",
    createPermission: LOCAL_OUTGOING_SHIPMENT_CREATE_PERMISSION,
    editPermission: LOCAL_OUTGOING_SHIPMENT_EDIT_PERMISSION,
    deletePermission: LOCAL_OUTGOING_SHIPMENT_DELETE_PERMISSION,
  },
  incoming: {
    label: "Incoming",
    api: LOCAL_INCOMING_SHIPMENT,
    vehicleTypesApi: LOCAL_INCOMING_SHIPMENT_VEHICLE_TYPES,
    listPath: "/local/incoming",
    addPath: "/local/add-incoming",
    editPath: "/local/edit-incoming",
    createPermission: LOCAL_INCOMING_SHIPMENT_CREATE_PERMISSION,
    editPermission: LOCAL_INCOMING_SHIPMENT_EDIT_PERMISSION,
    deletePermission: LOCAL_INCOMING_SHIPMENT_DELETE_PERMISSION,
  },
};

export const getLocalShipmentConfig = (pathname) =>
  pathname?.includes("incoming") ? configs.incoming : configs.outgoing;

export const DEFAULT_VEHICLE_TYPES = ["5 Ton", "3 Ton", "2 Ton", "1 Ton"];

export const mergeVehicleTypes = (list, ...types) => {
  const merged = [...list];
  types.forEach((type) => {
    const trimmed = type?.trim();
    if (
      trimmed &&
      !merged.some((item) => item.toLowerCase() === trimmed.toLowerCase())
    ) {
      merged.push(trimmed);
    }
  });
  return merged;
};
